<template>
    <v-dialog width="1200" v-model="showMilestoneTemplateForm" persistent scrollable>
        <v-card elevation="12">
            <v-card-title class="primary white--text pa-2 elevation-2">
                <div class="d-flex align-center">
                    <v-icon class="mr-3" size="28">mdi-flag-checkered</v-icon>
                    <div>
                        <h2 class="text-h5 font-weight-medium mb-1">
                            {{ editMode ? "Update" : "Add New" }} Milestone Template
                        </h2>

                    </div>
                </div>

                <v-spacer></v-spacer>

                <v-btn icon large @click="resetForm(), (showMilestoneTemplateForm = false)" class="hover-close-btn">
                    <v-icon class="white--text" size="24">mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="pa-6">
                <v-row class="ma-0">



                    <v-col cols="12" class="pt-0 mt-0">
                        <v-card class="rounded-lg overflow-y-auto" elevation="0">
                            <v-card-text class="pa-0">
                                <v-row class="ma-0 Height-Class">

                                    <v-col cols="12" lg="7">
                                        <v-card flat class="rounded-lg pl-1">
                                            <v-form @submit.prevent.stop ref="milestoneFormRef" v-model="isValid">
                                                <v-row class="ma-0">
                                                    <v-col cols="5">
                                                        <v-text-field id="template-name" v-model="template_name"
                                                            name="template-name" label="Template Name *" dense outlined
                                                            hide-details="auto" :rules="templateNameRules" required />
                                                    </v-col>

                                                    <v-col cols="5" class="d-flex justify-end">
                                                        <MultiSelect id="milestoneConfigList"
                                                            v-model="milestoneList.new_milestones"
                                                            name="milestoneConfigList" label="Select Custom Milestone "
                                                            :items="filteredMilestoneList" item-text="milestone_name"
                                                            item-value="id" multiple chips :return-object="true"
                                                            hide-details="auto"
                                                            :error-messages="formErrors.custom_milestone"
                                                            @input="onMilestoneInput" />
                                                    </v-col>


                                                </v-row>
                                            </v-form>
                                        </v-card>

                                        <v-list subheader>
                                            <draggable v-model="combinedMilestones" :options="dragOptions"
                                                @change="milestonesChanged" class="draggable-list">

                                                <v-row
                                                    v-for="(selectedMilestone, selectedMilestoneIndex) in combinedMilestones"
                                                    :key="selectedMilestone._id || selectedMilestone.id"
                                                    class="ma-0 mt-0 mb-2 pt-0 item">

                                                    <v-col cols="12">
                                                        <v-card outlined class="pa-2" color="#f5f7fa">
                                                            <!-- background color -->
                                                            <v-row class="ma-0">

                                                                <!-- Drag Icon -->
                                                                <v-col cols="1"
                                                                    class="align-self-center text-center pl-0 ml-0">
                                                                    <v-icon
                                                                        v-if="selectedMilestone.milestone_type !== 'System'"
                                                                        class="mdi-drag">
                                                                        mdi-drag
                                                                    </v-icon>
                                                                </v-col>

                                                                <!-- Icon + Number -->
                                                                <v-col cols="2"
                                                                    class="align-self-center text-center d-flex justify-space-around">
                                                                    <v-icon
                                                                        v-if="selectedMilestone.milestone_type == 'System'"
                                                                        color="primary">
                                                                        mdi-flag
                                                                    </v-icon>
                                                                    <v-icon v-else color="primary">
                                                                        mdi-flag-triangle
                                                                    </v-icon>

                                                                    <span class="text-h6 text--primary">
                                                                        #{{ selectedMilestoneIndex + 1 }}
                                                                    </span>
                                                                </v-col>

                                                                <v-divider vertical></v-divider>

                                                                <!-- Name -->
                                                                <v-col cols="6" class="align-self-center">
                                                                    <div class="d-flex">
                                                                        <span class="font-weight-bold">
                                                                            {{ selectedMilestone.milestone_name }}
                                                                        </span>
                                                                    </div>
                                                                    <v-chip class="mt-1" size="x-small"
                                                                        :color="selectedMilestone.milestone_type === 'System' ? 'blue' : 'green'"
                                                                        text-color="white">
                                                                        {{ selectedMilestone.milestone_type }}
                                                                    </v-chip>
                                                                </v-col>

                                                                <!-- Delete -->
                                                                <v-col cols="3" class="text-right">
                                                                    <v-btn
                                                                        v-if="selectedMilestone.milestone_type !== 'System'"
                                                                        icon color="error" medium
                                                                        @click="removeMilestone(selectedMilestoneIndex)">
                                                                        <v-icon size="25">mdi-trash-can-outline</v-icon>
                                                                    </v-btn>
                                                                    <v-btn v-else icon color="grey" disabled medium>
                                                                        <v-icon size="25">mdi-lock-outline</v-icon>
                                                                    </v-btn>

                                                                </v-col>

                                                            </v-row>
                                                        </v-card>
                                                    </v-col>

                                                </v-row>

                                            </draggable>
                                        </v-list>

                                    </v-col>

                                </v-row>

                            </v-card-text>
                        </v-card>
                    </v-col>




                </v-row>
            </v-card-text>
            <v-divider class="mx-0"></v-divider>
            <v-card-actions class="pa-1 grey lighten-5">
                <v-col cols="12" lg="12" class="d-flex justify-end">
                    <v-btn color="primary" depressed small class="mb-2" @click="submitForm">
                        <v-icon>mdi-plus</v-icon>
                        <span>Submit</span>
                    </v-btn>
                    <v-btn color="primary" depressed small class="mb-2 ml-2" @click="resetForm">
                        <v-icon>mdi-minus</v-icon>
                        <span>Reset</span>
                    </v-btn>

                </v-col>

            </v-card-actions>


        </v-card>

    </v-dialog>
</template>

<script>
import draggable from "vuedraggable";
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";

export default {
    components: {
        draggable,
        MultiSelect,
    },

    data() {
        return {
            isValid: true,
            template_name: "",
            itemsPerPage: 15,
            pageNo: 1,
            formErrors: {},
            selectedMilestone: {},
            systemMilestones: [],
            filteredMilestoneList: [],
            allLaneList: [],
            milestoneList: {
                custom_milestone: [],
                new_milestones: [],
                lane: []
            },
        };
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        editMode: {
            type: Boolean,
            default: false,
        },
        editMilestoneID: {
            type: [Number, null],
            default: null,
        },
    },
    watch: {
        value(val) {
            if (val) {
                // this.getMilestoneOptions();
                if (this.editMode) {
                    this.getMilestoneTemplateObject(this.editMilestoneID);
                }
            } else {
                this.resetForm();
            }
        },
    },

    computed: {
        showMilestoneTemplateForm: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
        offset() {
            return this.itemsPerPage * (this.pageNo - 1);
        },
        combinedMilestones: {
            get() {
                const systemMilestones = (this.milestoneList && this.milestoneList.custom_milestone
                    ? this.milestoneList.custom_milestone.map((item, index) => ({
                        ...item,
                        _id: `system_${index}`,
                        _type: "system",
                    }))
                    : []);

                const customMilestones = (this.milestoneList && this.milestoneList.new_milestones
                    ? this.milestoneList.new_milestones.map((item, index) => ({
                        ...item, _id: `custom_${index}`,
                        _type: "custom",
                    }))
                    : []);

                return [...systemMilestones, ...customMilestones].sort(
                    (a, b) => a.sequence - b.sequence
                );
            },
            set(newValue) {
                newValue.forEach((item, index) => {
                    item.sequence = index + 1;
                });

                const systemMilestones = newValue.filter(
                    (item) => item.milestone_type === "System"
                );

                const customMilestones = newValue.filter(
                    (item) => item.milestone_type !== "System"
                );

                // Update the original lists
                if (this.milestoneList) {
                    this.milestoneList.custom_milestone = systemMilestones;
                    this.milestoneList.new_milestones = customMilestones;
                }
            },
        },




        dragOptions() {
            return {
                animation: 300,
                sort: true,
                group: "milestoneGroup",
                disabled: false,
                ghostClass: "ghost",
                handle: ".mdi-drag",
            };
        },

        templateNameRules() {
            return [
                (val) => !!val || 'Template Name is Required!',
            ];
        },

        laneRules() {
            return [
                (v) => !!v || 'Lane is required'
            ];
        }
    },

    async beforeMount() {
        this.getMilestonConfigurationList();

        if (this.$route?.params?.id) {
            this.editMode = true;
            await this.getMilestoneTemplateObject(this.editMilestoneID);
        }
    },

    methods: {
        onMilestoneInput() {
            this.$delete(this.formErrors, 'custom_milestone');
        },


        async milestonesChanged() {
            await this.updateAllMilestones();
        },


        async removeMilestone(index) {
            const milestone = this.combinedMilestones[index];

            if (milestone._type === "system" || milestone.milestone_type == 'System') {
                const systemIndex = this.milestoneList.custom_milestone.findIndex(
                    (item) =>
                        item._id === milestone._id ||
                        (item.id === milestone.id &&
                            item.custom_milestone === milestone.custom_milestone)
                );
                if (systemIndex !== -1) {
                    this.milestoneList.custom_milestone.splice(systemIndex, 1);
                }
            } else {
                const customIndex = this.milestoneList.new_milestones.findIndex(
                    (item) =>
                        item._id === milestone._id ||
                        (item.id === milestone.id &&
                            item.custom_milestone === milestone.custom_milestone)
                );
                if (customIndex !== -1) {
                    this.milestoneList.new_milestones.splice(customIndex, 1);
                }
            }
            await this.updateAllMilestones();
        },

        async updateAllMilestones() {
            this.combinedMilestones.forEach((item, index) => {
                item.sequence = index + 1;
            });
        },

        getMilestoneTemplateObject(id) {
            this.$bus.$emit("showLoader", true);
            this.$api.milestoneTemplate
                .getMilestoneTemplateObject(id)
                .then((res) => {
                    this.$bus.$emit("showLoader", false);
                    this.milestoneList.new_milestones = res.data?.milestone_template
                        .filter((item) => item.milestone_type !== "System")
                        .sort((a, b) => a.sequence - b.sequence);

                    this.milestoneList.custom_milestone = res.data?.milestone_template
                        .filter((item) => item.milestone_type === "System")
                        .sort((a, b) => a.sequence - b.sequence);


                    this.template_name = res.data?.name;
                    console.log("232", this.milestoneList.new_milestones)
                })
                .catch((err) => {
                    this.$bus.$emit("showLoader", false);
                });
        },


        getMilestonConfigurationList(params = {}) {
            this.$bus.$emit("showLoader", true);
            params = {
                limit: "all",
                ...params,
            };
            if (params.ordering && params.ordering.length > 0) {
                params = { ...params, ordering: params.ordering.join(",") };
            }

            this.$api.milestone
                .getMilestoneList(params)
                .then((res) => {
                    this.$bus.$emit("showLoader", false);
                    this.filteredMilestoneList = res.data
                        .filter(
                            (milestone) => milestone.milestone_type !== "System"
                        )

                        .map((item) => {
                            return Object.fromEntries(
                                Object.entries(item).map(([key, value]) => [
                                    key.replace(/id/g, "custom_milestone"),
                                    value,
                                ])
                            );
                        });

                    if (!this.editMode) {
                        this.milestoneList.custom_milestone = res.data
                            .filter(
                                (milestone) => milestone.milestone_type === "System"
                            )

                            .reverse();
                    }
                })
                .catch((err) => {
                    this.formErrors = err.data.error;
                    if (err && err.data) {
                        const showToast = (message) => {
                            this.$bus.$emit("showToastMessage", {
                                message,
                                color: "error",
                                hasActions: true,
                            });
                        };

                        if (err.data.message) {
                            showToast(err.data.message);
                        } else if (
                            err.data.error &&
                            err.data.error.non_field_errors &&
                            err.data.error.non_field_errors.length
                        ) {
                            showToast(err.data.error.non_field_errors.join(", "));
                        } else {
                            showToast("Fetch MilestoneConfiguration List Failed");
                        }
                    }
                    this.$bus.$emit("showLoader", false);
                });
        },

        submitForm(payload = {}) {
            this.updateAllMilestones();
            payload = {
                ...payload,
                name: this.template_name,
                milestone_template: [],
            };
            console.log(this.combinedMilestones)

            if (this.combinedMilestones && this.combinedMilestones.length) {
                payload.milestone_template = this.combinedMilestones.map((t, index) => {
                    return {
                        milestone: t.id || t.milestone || t.custom_milestone,
                        sequence: index + 1,
                        milestone_type: t.milestone_type,
                        name: t.milestone_name

                    };
                });
            }

            if (this.editMode) {
                this.$api.milestoneTemplate
                    .updateMilestoneTemplate({ id: this.editMilestoneID, data: payload })
                    .then((res) => {
                        this.$bus.$emit("showLoader", false);
                        this.$bus.$emit("showToastMessage", {
                            message: "Milestone Template Updated Successfully!",
                            color: "success",
                        });
                        this.showMilestoneTemplateForm = false
                               this.$emit("refreshTemplate");
                    })
                    .catch((err) => {
                        this.formErrors = err.data.error;
                        if (err && err.data) {
                            const showToast = (message) => {
                                this.$bus.$emit("showToastMessage", {
                                    message,
                                    color: "error",
                                    hasActions: true,
                                });
                            };

                            if (err.data.message) {
                                showToast(err.data.message);
                            } else if (
                                err.data.error &&
                                err.data.error.non_field_errors &&
                                err.data.error.non_field_errors.length
                            ) {
                                showToast(err.data.error.non_field_errors.join(", "));
                            } else {
                                showToast("Milestone Template Update Failed");
                            }
                        }
                        this.$bus.$emit("showLoader", false);
                    });
            } else {
                this.$api.milestoneTemplate
                    .addMilestoneTemplate(payload)
                    .then((res) => {
                        this.$bus.$emit("showLoader", false);
                        this.$bus.$emit("showToastMessage", {
                            message: "Milestone Template Added Successfully!",
                            color: "success",
                        });
                        this.showMilestoneTemplateForm = false
                               this.$emit("refreshTemplate");
                    })
                    .catch((err) => {
                        this.formErrors = err.data.error;
                        if (err && err.data) {
                            const showToast = (message) => {
                                this.$bus.$emit("showToastMessage", {
                                    message,
                                    color: "error",
                                    hasActions: true,
                                });
                            };

                            if (err.data.message) {
                                showToast(err.data.message);
                            } else if (
                                err.data.error &&
                                err.data.error.non_field_errors &&
                                err.data.error.non_field_errors.length
                            ) {
                                showToast(err.data.error.non_field_errors.join(", "));
                            } else {
                                showToast("Milestone Template Creation Failed");
                            }
                        }
                        this.$bus.$emit("showLoader", false);
                    });
            }
        },

        resetForm() {
            this.milestoneList.new_milestones = [];
            this.template_name = null;
            this.formErrors = {};

            if (
                this.milestoneList &&
                this.milestoneList.custom_milestone &&
                this.milestoneList.custom_milestone.length
            ) {
                this.milestoneList.custom_milestone.sort(
                    (a, b) => (a.sequence || 0) - (b.sequence || 0)
                );
            }

            if (this.$refs.milestoneFormRef) {
                this.$refs.milestoneFormRef.resetValidation();
            }
        },
    },
};
</script>

<style scoped>
.Height-Class {
    max-height: calc(80vh);
    overflow-y: auto;
}

.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}

.draggable-list .item {
    cursor: move;
}
</style>